import { makeAutoObservable, runInAction } from 'mobx'
import { bannerStore, EnumAlertBannerVariant } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { BillingPath } from 'pages/settings/pages/billing/route/billingPath'

const BANNER_TITLE_BILLING_ACCESS =
  "Your credit card couldn't be charged. Update your auto-recharge payment method."
const BANNER_TITLE_NO_BILLING_ACCESS =
  "Your credit card couldn't be charged. Ask your admin or owner to update auto-recharge payment method."

export class AutorechargeFailureBannerStore {
  private _banner_id = 'autorecharge_failure_banner'
  private _initialized = false

  constructor(readonly entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  init = async () => {
    await Promise.allSettled([
      this.entities.billingStore.fetchAutorecharge(),
      this.entities.userPermissionsStore.fetchUserPermissions(),
    ])

    runInAction(() => {
      this._initialized = true
    })
  }

  initBanner = () => {
    if (this.show) {
      bannerStore.add({
        id: this._banner_id,
        alert: {
          title: this.canManageBilling
            ? BANNER_TITLE_BILLING_ACCESS
            : BANNER_TITLE_NO_BILLING_ACCESS,
          variant: EnumAlertBannerVariant.Error,
          ariaLabel: 'autorecharge_failure_banner',
        },
        action: this.canManageBilling
          ? {
              text: 'Update',
              onAction: () => {
                this.onAction()
              },
            }
          : undefined,
        actionClose: {
          closeId: this._banner_id,
        },
      })
    } else {
      bannerStore.remove(this._banner_id)
    }
  }

  dispose = () => {
    bannerStore.remove(this._banner_id)
  }

  onAction = () => {
    bannerStore.remove(this._banner_id)

    uiStore.changeRouteViaVue({
      path: `/${BillingPath.overview}`,
    })

    this.dispose()
  }

  get show() {
    return this._initialized && this._autorechargeFailure
  }

  get canManageBilling() {
    return this.entities.userPermissionsStore.canManageBilling
  }

  private get _autorechargeFailure() {
    return Boolean(this.entities.billingStore.autorecharge?.failure)
  }
}
